import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { redirect } from "react-router-dom";
import Cookies from "js-cookie";

import { Header } from "../../component/header/Header";
import { SideBar } from "../../component/sideBar/SideBar";
import classes from "./dashBoard.module.css";

export const DashBoardPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className={classes.container}>
      {/* Header */}
      <Header onMenuClick={() => setIsSidebarOpen(true)} />

      <div className={classes.container__outlet}>
        {/* Sidebar */}
        <SideBar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        {/* Page Content */}
        <div
          className={classes.container__outlet__box}
          onClick={() => isSidebarOpen && setIsSidebarOpen(false)}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

/* ===============================
   Auth Guard
================================ */
export function checkAuthLoader() {
  const token = Cookies.get("token");
  const expirationTime = Cookies.get("expirationTime");

  if (!token || !expirationTime) {
    return redirect("login");
  }

  return null;
}
